export const testimonials = [
    {
        discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.Perferendis obcaecati dicta repellendus soluta, quos esse error odit dignissimos dolorem est.",
        icon: "assets/img/home/icons.png",
        image: "assets/img/home/men.png",
        name: "Dominika smith",
        title: "senior Software marketing manager"
    },
    {
        discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.Perferendis obcaecati dicta repellendus soluta, quos esse error odit dignissimos dolorem est.",
        icon: "assets/img/home/icons.png",
        image: "assets/img/home/men.png",
        name: "Dominika smith",
        title: "senior Software marketing manager"
    },
    {
        discription: "Lorem ipsum dolor sit amet consectetur, adipisicing elit.Perferendis obcaecati dicta repellendus soluta, quos esse error odit dignissimos dolorem est.",
        icon: "assets/img/home/icons.png",
        image: "assets/img/home/men.png",
        name: "Dominika smith",
        title: "senior Software marketing manager"
    },
]